import React from 'react';

const AwsSns = () => {
  return (
    <>
      <h5>
        <b>AWS SNS</b>
      </h5>
      <p>
        Amazon Simple Notification Service (SNS) is a cost-effective, flexible, and scalable
        messaging service that enables developers to send SMS messages to users globally.
      </p>
      <br />
    </>
  );
};

export default AwsSns;
